import { whyFeatures } from "../../../mocks/cleario";
import WaveDivider from "./WaveDivider";

const cardBg = ["bg-cl-tint", "bg-cl-lime/25", "bg-cl-lime/25", "bg-cl-tint"];
const iconColors = [
  "bg-cl-lime border-cl-green text-cl-green",
  "bg-cl-dark text-white border-[#09245b]",
  "bg-cl-lime border-cl-green text-cl-green",
  "bg-cl-dark text-white border-[#09245b]",
];

export default function WhyClearioSection() {
  return (
    <div>
      <section className="py-20 bg-white">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10">

          {/* Header */}
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
            <div>
              <div className="inline-flex items-center gap-2 bg-cl-lime rounded-full px-4 py-1.5 mb-5 thick-border cartoon-shadow-sm">
                <span className="text-cl-dark text-xs font-black uppercase tracking-widest">Why We&apos;re Different</span>
              </div>
              <h2 className="text-4xl md:text-5xl font-black text-cl-dark leading-tight">
                Not just another<br />van on your drive.
              </h2>
            </div>
            <p className="text-cl-dark/60 text-base max-w-md leading-relaxed font-semibold">
              Plenty of companies will take your rubbish. We&apos;re the ones who actually care what happens to it next — and we&apos;ve got the paperwork to back it up.
            </p>
          </div>

          {/* Features — alternating layout for visual interest */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {whyFeatures.map((feature, i) => (
              <div
                key={i}
                className={`flex items-start gap-5 p-7 rounded-3xl thick-border cartoon-shadow-sm ${cardBg[i]}`}
              >
                <span
                  className={`w-14 h-14 flex items-center justify-center rounded-2xl border-2 text-2xl flex-shrink-0 cartoon-shadow-sm ${iconColors[i]}`}
                >
                  <i className={feature.icon}></i>
                </span>
                <div>
                  <h3 className="font-black text-xl mb-2 text-cl-dark">{feature.title}</h3>
                  <p className="text-cl-dark/70 text-sm leading-relaxed font-semibold">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <WaveDivider fromColor="#ffffff" toColor="#09245b" />
    </div>
  );
}